import React from 'react'
import Link from 'gatsby-link'
import CustomerQuote from '../components/customerQuote'
import HowItWorks from '../components/howItWorks';
import CurrentBundle from '../components/currentBundle';
import PriceBox from '../components/priceBox';
import TestimonialBlock from '../components/testimonialBlock';


const IndexPage = (props) => (
  <div>
      <CustomerQuote />
      <HowItWorks />
      <CurrentBundle />
      <PriceBox />
      <TestimonialBlock />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js